import { render, staticRenderFns } from "./holiday.vue?vue&type=template&id=1c15a40b"
import script from "./holiday.vue?vue&type=script&lang=js"
export * from "./holiday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c15a40b')) {
      api.createRecord('1c15a40b', component.options)
    } else {
      api.reload('1c15a40b', component.options)
    }
    module.hot.accept("./holiday.vue?vue&type=template&id=1c15a40b", function () {
      api.rerender('1c15a40b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/holiday/holiday.vue"
export default component.exports